/* eslint-disable array-callback-return */
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import sanityClient from "../Client";
import * as AiIcons from "react-icons/ai";

const FeaturedWork = () => {
  const [projects, setProjects] = useState(null);
  const [projectCount, setProjectCount] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "work"] {
            title,
            slug,
            featured,
            mainImage{
              asset->{
                  _id,
                  url
              },
              alt,
            },
            category,
            tagline,
            description,
            comingSoon,
            role,
            year,
            type,
            awards,
            link
        }`
      )
      .then((data) => {
        setProjectCount(data.length);
        const featuredItems = data?.filter((item) => {
          if (item.featured) return item;
        });
        setProjects(
          featuredItems?.sort((a, b) =>
            a.year < b.year ? 1 : -1 && a.title > b.title ? 1 : -1
          )
        );
      })
      .catch(console.error);
  }, []);

  return (
    <motion.div
      className="featured-work"
      //   initial={{
      //     opacity: 0.75,
      //     clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
      //   }}
      //   whileInView={{
      //     opacity: 1,
      //     clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
      //   }}
      //   transition={{ duration: 0.5, delay: 0.1 }}
    >
      <div className="featured-title">
        <span>Recent Work</span>
      </div>
      <div className="featured-items">
        {projects?.map((item) => (
          <Link
            to={"/work/" + item.slug.current}
            key={item.slug.current}
            className="featured-item"
          >
            <div
              className="work-item-img-container"
              style={{
                backgroundImage: `url(${item.mainImage?.asset.url})`,
              }}
            >
              <div className="work-item-btn-container">
                <div>
                  <AiIcons.AiOutlinePlus />
                </div>
              </div>
            </div>
            <div className="work-item-text-container">
              <div className="work-item-text">
                <h3 className="work-item-title">{item.title}</h3>
                <p className="work-item-role">{item.role}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <Link className="view-more-btn" to="/Work">
        All Work
        <sup>{projectCount}</sup>
      </Link>
    </motion.div>
  );
};

export default FeaturedWork;
